module.exports = __webpack_public_path__ + "img/mg-hiw.09f901a7.png";